// extracted by mini-css-extract-plugin
module.exports = {"right":"styles_right___y4Z9"};